import { render } from "./BravoPay.vue?vue&type=template&id=051d724c&scoped=true"
import script from "./BravoPay.vue?vue&type=script&lang=js"
export * from "./BravoPay.vue?vue&type=script&lang=js"

import "./BravoPay.vue?vue&type=style&index=0&id=051d724c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051d724c"]])

export default __exports__